import { FC, useEffect, useState } from 'react'
import { useIntl } from 'react-intl';
import { useQueryRequest } from '../core/QueryRequestProvider'
import { getAll, getOneByIdbylang } from '../../../../services/common_requests'
import { recommendedSizeFor } from '../../../../utils/imagePlacements'

interface ImageEditModalProps {
    isOpen: boolean;
    onClose: () => void;
    selectedImage: { id?:string ,url: string; seoUrl?: string };
    selectedSlider: any;
    selectedSliderItemId: any;
    onSave: (updatedImage: { url: string; seoUrl?: string; link?: string; translations?: any[] }) => void;
}

type SliderItemTranslation = {
    _id?: string;
    language?: string;
    text?: string;
    description?: string;
    buttonText?: string;
};

const ImageEditModal: React.FC<ImageEditModalProps> = ({ isOpen, onClose, selectedImage, selectedSlider, selectedSliderItemId, onSave }) => {
    const [seoUrl, setSeoUrl] = useState(selectedImage.seoUrl || '');
    const [newImage, setNewImage] = useState<File | null>(null);
    const [previewImage, setPreviewImage] = useState(selectedImage.url);
    const [link, setLink] = useState(selectedSlider.link);
    const [videoType, setVideoType] = useState<string>(selectedSlider.videoType || 'youtube');
    const [videoUrl, setVideoUrl] = useState<string>(selectedSlider.videoUrl || '');
    const [videoAutoplay, setVideoAutoplay] = useState<boolean>(!!selectedSlider.videoAutoplay);
    const [videoLazy, setVideoLazy] = useState<boolean>(selectedSlider.videoLazy !== false);
    const [translations, setTranslations] = useState(
      (Array.isArray(selectedSlider.translations) ? selectedSlider.translations : []).filter(Boolean).length
        ? [(Array.isArray(selectedSlider.translations) ? selectedSlider.translations : []).filter(Boolean)[0]]
        : [{
            language: 'en',
            text: '',
            description: '',
            buttonText: '',
          }],
    );
    const { state } = useQueryRequest();
    const [query, setQuery] = useState<any>(state);
    
    const intl = useIntl()
    useEffect(() => {
        setSeoUrl(selectedImage.seoUrl || '');
        setPreviewImage(selectedImage.url);
    }, [selectedImage]);

    const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files[0]) {
            const file = e.target.files[0];
            setNewImage(file);
            setPreviewImage(URL.createObjectURL(file));
        }
    };
    const LANGUAGE_NAMES: { [key: string]: string } = {
        en: intl.formatMessage({ id: 'COMMON.ENGLISH_LANGUAGE' }),
        fr: intl.formatMessage({ id: 'COMMON.FRENSH_LANGUAGE' }),
        es: intl.formatMessage({ id: 'COMMON.ESPANGOL_LANGUAGE' }),
        de: intl.formatMessage({ id: 'COMMON.GERMAN_LANGUAGE' }),
        ar: intl.formatMessage({ id: 'COMMON.ARABIC_LANGUAGE' }),
      };
    
    const [languages, setLanguages] = useState<{ code: string; name: string }[]>([]);
    const [selectedLanguage, setSelectedLanguage] = useState('en');
    useEffect(() => {
        if (languages.length > 0) {
          setSelectedLanguage(languages[0].code);
        }
      }, [languages]);
      useEffect(() => {
        getAll(query, '/languages').then((data) => {
          if (data && Array.isArray(data)) {
  
            const formattedLanguages = data.map((code: string) => ({
              code,
              name: LANGUAGE_NAMES[code] || code.toUpperCase(),
            }));
            setLanguages(formattedLanguages);
          }
        });
      }, [query]);

      useEffect(() => {
        if (!(selectedSliderItemId && selectedLanguage)) {
          return;
        }
        getOneByIdbylang(`/sliders/item/${selectedSliderItemId}?language=${selectedLanguage}`)
          .then((data) => {
            if (!data) {
              return;
            }
            setSeoUrl(data.image?.seoUrl || data.seoUrl || selectedImage.seoUrl);
            setLink(data.link || '');
            setVideoType(data.videoType || 'youtube');
            setVideoUrl(data.videoUrl || '');
            setVideoAutoplay(!!data.videoAutoplay);
            setVideoLazy(data.videoLazy !== false);
            const list = (Array.isArray(data.translations) ? data.translations : []).filter(
              (item: SliderItemTranslation | null | undefined): item is SliderItemTranslation => Boolean(item),
            );
            const current =
              list.find((t: SliderItemTranslation) => t.language === selectedLanguage) || list[0];
            setTranslations(
              current
                ? [{ ...current, language: selectedLanguage }]
                : [{
                    language: selectedLanguage,
                    text: data.text || '',
                    description: data.description || '',
                    buttonText: data.buttonText || '',
                  }],
            );
            setPreviewImage(data.image?.url || data.url || selectedImage.url);
          });
      }, [selectedLanguage, selectedSliderItemId]);

    const handleSave = () => {
        const currentTranslation = {
            ...(translations[0] || {}),
            language: selectedLanguage,
            text: translations[0]?.text || '',
            description: translations[0]?.description || '',
            buttonText: translations[0]?.buttonText || '',
        };
        const updatedItem = {
            imageId: selectedImage.id,

            url: newImage ? URL.createObjectURL(newImage) : selectedImage.url,
            seoUrl: seoUrl,
            link: link,
            videoType,
            videoUrl,
            videoAutoplay,
            videoLazy,
            translations: [currentTranslation],
          };
          const formData = new FormData();
          if (selectedImage.id) {
            formData.append('imageId', selectedImage.id);
            formData.append('seoUrl', seoUrl);
            if (newImage) {
              formData.append('image', newImage);
              formData.append('placement', 'slider');
            }
          }

          formData.append('link', link);
          formData.append('videoType', videoType || '');
          formData.append('videoUrl', videoUrl || '');
          formData.append('videoAutoplay', String(!!videoAutoplay));
          formData.append('videoLazy', String(videoLazy !== false));
          formData.append('translations[0][text]', translations[0]?.text);
          formData.append('translations[0][language]', translations[0]?.language);
          formData.append('translations[0][description]', translations[0]?.description);
          formData.append('translations[0][buttonText]', translations[0]?.buttonText);

        console.log('updatedImage',updatedItem)

        onSave(updatedItem);
    };

    if (!isOpen) return null;

    const handleLanguageChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const newLanguage = e.target.value;
        setSelectedLanguage(newLanguage);
      
      };
    return (
        <div className="modal modal-style">
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">{intl.formatMessage({
                            id: 'COMMON.UPDATE_IMAGE'
                        })}</h5>
                        <button type="button" className="btn-close" onClick={onClose}></button>
                    </div>
                    <div className="modal-body">
                        <img
                            src={previewImage.includes('/images/') ? process.env.REACT_APP_API_URL_IMAGE + previewImage : previewImage}
                            alt="Selected"
                            className='modal-body-image'
                           
                        />
                        <div className="form-group mb-3">
                            <label>{intl.formatMessage({
                                id: 'COMMON.UPLOAD_IMAGE',
                            })}</label>
                            <input
                                type="file"
                                className="form-control"
                                accept="image/png,image/jpeg,image/jpg,image/webp,.png,.jpg,.jpeg,.webp"
                                onChange={handleImageChange}
                            />
                            <div className='form-text text-muted mt-2 mb-0'>
                              {intl.formatMessage(
                                { id: 'COMMON.IMAGE.RECOMMENDED_SIZE' },
                                { size: recommendedSizeFor('slider') },
                              )}
                            </div>
                        </div>
                        {typeof selectedImage.url === 'string' && (
                            <div className="form-group">
                                <label>{intl.formatMessage({
                                    id: 'COMMON.ALT_IMAGE',
                                })} </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={seoUrl || ''}
                                    onChange={(e) => setSeoUrl(e.target.value)}
                                />
                            </div>
                        )}
                    <div className="form-group mb-3">
                    <label>{intl.formatMessage({ id: 'COLUMNS.LINK' })}</label>
                    <input
                        type="text"
                        className="form-control"
                        value={link || ''}
                        onChange={(e) => setLink(e.target.value)}
                    />
                    </div>

                    {/* Vidéo du slide (support multi-formats : YouTube, Vimeo, Reels, TikTok, Facebook, Instagram, MP4 hébergé, etc.) */}
                    <div className="form-group mb-3 border-top pt-3">
                        <label className='fw-bold d-block mb-2'>
                            {intl.formatMessage({ id: 'SLIDER.VIDEO.TITLE' })}
                        </label>
                        <div className='form-text text-muted mb-2'>
                            {intl.formatMessage({ id: 'SLIDER.VIDEO.HINT' })}
                        </div>
                        <label className='form-label'>{intl.formatMessage({ id: 'SLIDER.VIDEO.TYPE' })}</label>
                        <select
                            className='form-select mb-2'
                            value={videoType}
                            onChange={(e) => setVideoType(e.target.value)}
                        >
                            <option value='youtube'>YouTube</option>
                            <option value='vimeo'>Vimeo</option>
                            <option value='dailymotion'>Dailymotion</option>
                            <option value='facebook'>Facebook</option>
                            <option value='tiktok'>TikTok</option>
                            <option value='instagram'>Instagram (Reels)</option>
                            <option value='mp4'>MP4 (hébergé)</option>
                            <option value='url'>Lien direct</option>
                        </select>
                        <label className='form-label'>{intl.formatMessage({ id: 'SLIDER.VIDEO.URL' })}</label>
                        <input
                            type='text'
                            className='form-control mb-2'
                            placeholder={intl.formatMessage({ id: 'SLIDER.VIDEO.URL_PLACEHOLDER' })}
                            value={videoUrl}
                            onChange={(e) => setVideoUrl(e.target.value)}
                        />
                        <div className='form-check form-switch mb-1'>
                            <input
                                className='form-check-input'
                                type='checkbox'
                                id='videoAutoplay'
                                checked={videoAutoplay}
                                onChange={(e) => setVideoAutoplay(e.target.checked)}
                            />
                            <label className='form-check-label' htmlFor='videoAutoplay'>
                                {intl.formatMessage({ id: 'SLIDER.VIDEO.AUTOPLAY' })}
                            </label>
                        </div>
                        <div className='form-check form-switch'>
                            <input
                                className='form-check-input'
                                type='checkbox'
                                id='videoLazy'
                                checked={videoLazy}
                                onChange={(e) => setVideoLazy(e.target.checked)}
                            />
                            <label className='form-check-label' htmlFor='videoLazy'>
                                {intl.formatMessage({ id: 'SLIDER.VIDEO.LAZY' })}
                            </label>
                        </div>
                    </div>
                                {/* Language Selector */}
                    <div className="form-group mb-3">
                    <label>{intl.formatMessage({ id: 'COLUMNS.LANGUAGE' })}</label>
                    <select
                        className="form-select"
                        value={selectedLanguage}
                        onChange={handleLanguageChange}
                    >
                        {languages.map((lang) => (
                        <option key={lang.code} value={lang.code}>
                            {lang.name}
                        </option>
                        ))}
                    </select>
                    </div>

                    <div key={'1'} className="form-group mb-3">
                        <label>{intl.formatMessage({ id: 'COLUMNS.TEXT' })} ({translations[0]?.language})</label>
                        <input
                        type="text"
                        className="form-control"
                        value={translations[0]?.text || ''}
                        onChange={(e) => {
                            const updatedTranslations = [...translations];
                            updatedTranslations[0].text = e.target.value;
                            setTranslations(updatedTranslations);
                        }}
                        />
                        <label>{intl.formatMessage({ id: 'COLUMNS.DESCRIPTION' })} ({translations[0]?.language})</label>
                        <input
                        type="text"
                        className="form-control"
                        value={translations[0]?.description || ''}
                        onChange={(e) => {
                            const updatedTranslations = [...translations];
                            updatedTranslations[0].description = e.target.value;
                            setTranslations(updatedTranslations);
                        }}
                        />
                        <label>{intl.formatMessage({ id: 'COLUMNS.BUTTON_TEXT' })} ({translations[0]?.language})</label>
                        <input
                        type="text"
                        className="form-control"
                        value={translations[0]?.buttonText || ''}
                        onChange={(e) => {
                            const updatedTranslations = [...translations];
                            updatedTranslations[0].buttonText = e.target.value;
                            setTranslations(updatedTranslations);
                        }}
                        />
                    </div>

</div>

                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={onClose}>{intl.formatMessage({
                            id: 'HEADER.RESET',
                        })}</button>
                        <button type="button" className="btn btn-primary" onClick={handleSave}>{intl.formatMessage({
                            id: 'HEADER.SAVE',
                        })}</button>
                    </div>
                  </div>

                </div>
            </div>
    );
};

export default ImageEditModal;